<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >

    <router-link to="/">
      <div class="d-flex align-center">
        <img src="./assets/logo_2025_web.png" width="70">
      </div>
      </router-link>
      <v-spacer></v-spacer>

      <v-toolbar-title>Csigavér Diák Portál</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item to="/adatok" color="#FF9800" v-if="customer_id">
            <v-list-item-title>Személyes adatok<v-icon right>perm_contact_calendar</v-icon></v-list-item-title>
          </v-list-item>
          <v-list-item to="/jogsi" color="#FF9800" v-if="customer_id">
            <v-list-item-title>Vezetői engedély<v-icon right>picture_in_picture</v-icon></v-list-item-title>
          </v-list-item>
          <v-list-item to="/kategoriak" color="#FF9800" v-if="customer_id">
            <v-list-item-title>Kategóriák<v-icon right>bike_scooter</v-icon></v-list-item-title>
          </v-list-item>
          <v-list-item to="/tanfolyamok" color="#FF9800" v-if="customer_id">
            <v-list-item-title>Tanfolyamok<v-icon right>school</v-icon></v-list-item-title>
          </v-list-item>
          <v-list-item to="/vizsgak" color="#FF9800" v-if="customer_id">
            <v-list-item-title>Vizsgák<v-icon right>date_range</v-icon></v-list-item-title>
          </v-list-item>
          <v-list-item to="/gyakorlat" color="#FF9800" v-if="customer_id">
            <v-list-item-title>Gyakorlat<v-icon right>drive_eta</v-icon></v-list-item-title>
          </v-list-item>
          <v-list-item to="/penzugy" color="#FF9800" v-if="customer_id">
            <v-list-item-title>Befizetések<v-icon right>attach_money</v-icon></v-list-item-title>
          </v-list-item>
          <v-list-item to="/login" color="#FF9800">
            <v-list-item-title>{{signed}}<v-icon right>power_settings_new</v-icon></v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

          <v-progress-linear :active="preloader" :indeterminate="preloader" absolute bottom color="teal"></v-progress-linear>

    </v-app-bar>

    <div class="mb-12"></div>
    <div class="mb-6"></div>

    <v-tooltip bottom v-if="customer_id">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          fixed
          @click="message_dialog = true"
          dark
          fab
          bottom
          right
          small
          color="blue"
        >
        <v-icon>chat</v-icon>
        </v-btn>
      </template>
      <span>Üzenet az ügyfélszolgálatnak</span>
    </v-tooltip>

  <v-dialog
    v-model="message_dialog"
    persistent
    max-width="600"
  >
  <v-card>
    <v-card-title class="headline">
      Üzenet küldése
    </v-card-title>
    <v-card-text>
      <v-col
        cols="12"
      >
        <v-textarea
          v-model="message"
          outlined
          label="Üzenet szövege"
          auto-grow
        ></v-textarea>
      </v-col>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="green"
        text
        outlined
        rounded
        @click="sendMessage()"
        :disabled="!message"
      >
        Küld
      <v-icon right>send</v-icon>
      </v-btn>
      <v-btn
        color="red"
        text
        outlined
        rounded
        @click="message_dialog = false"
      >
        Mégsem
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<v-snackbar v-model="response_snackbar" bottom>
  {{ message_response }}
  <v-btn color="pink" text @click="response_snackbar = false">
    Bezár
  </v-btn>
</v-snackbar>

<v-footer padless absolute>
  <v-col
    class="text-center footer"
    cols="12"
  >
    {{ new Date().getFullYear() }} — <a href="https://szoftver-fejlesztes.csigaver.hu" target="_blank">Csigavér Webfejlesztés</a>
  </v-col>
</v-footer>

    <keep-alive>
      <router-view></router-view>
    </keep-alive>

    <div class="mb-12"></div>

  </v-app>
</template>

<script>
//import store from './store'
import {mapFields} from 'vuex-map-fields'
import firebase from 'firebase/app'
import 'firebase/auth';

export default {
  name: 'App',

  components: {

  },

  data () {
    return {
      response: '',
      message_response: '',
      message: '',
      response_snackbar: false,
      signed: '',
    }
  },
  methods: {
    userState: async function () {
      await this.gettoken()
      var user = firebase.auth().currentUser;
      if (user) {
        this.$http.post('/login/check_customer', {
          token: this.token,
        }).then((response) => {
          this.customer_name = response.data[0]['full_name']
          this.customer_id = response.data[0]['customer_id']
        }, (error) => {
          console.log(error.data);
        })
      } else {
        console.log("No user is signed in.");
      }
    },
    contractList: async function() {
      this.preloader = true
      await this.gettoken()
      this.$http.post('/adatok/contract_list', {
        token: this.token
      }).then((response) => {
        this.preloader = false
        this.contracts = response.data
        if (this.contracts != '') {
          this.contract_id = this.contracts[0]['contract_id']
          this.nkh_course_type_id = this.contracts[0]['course_type_key']
          this.contract_driving_school = this.contracts[0]['school_id']
        }
      }, (error) => {
        console.log(error.data);
      })
    },
    sendMessage: async function () {
      this.message_dialog = false
      await this.gettoken()
        this.$http.post('/adatok/office_message', {
          token: this.token,
          contract_id: this.contract_id,
          message: this.message
        }).then((response) => {
          this.message_response = response.data;
          this.response_snackbar = true
          this.message = ''
        }, (error) => {
          console.log(error.data);
        })
    },
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.userState();
      }
    })
  },
  watch: {
    customer_id: function(value) {
      if (value) {
        this.contractList();
        this.signed = 'Kilépés';
      } else {
        this.signed = 'Belépés';
      }
    }
  },
  computed: {
  ...mapFields([
    'ids.customer_id',
    'ids.contract_id',
    'ids.contract_driving_school',
    'ids.nkh_course_type_id',
    'user_datas.contracts',
    'ids.customer_name',
    'actions.preloader',
    'actions.message_dialog',
]),
},
};
</script>

<style lang="css">
.footer {
  font-size: 12px;
}
/* unvisited link */
a:link {
  color: black !important;
  text-decoration: none;
}

/* visited link */
a:visited {
  color: black !important;
}

/* mouse over link */
a:hover {
  color: black !important;
}

/* selected link */
a:active {
  color: black !important;
}
</style>
